// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1Axif","label":"LabeledBox_label__tzKiy"};